var _span, _img;
import CrehanaLogo from '@crehana/compass.icons.fill/Crehana';
import { createUrlWithSourceQueryParams } from '@crehana/utils';
import { Container } from "../../Grid";
import LazyImage from "../../LazyImage/LazyImage";
import { Button } from "../Button/Button";
import { cn } from "../utils";
import useTranslationsError from "./hooks/use-translations-no-permission";
import CrehanaTextImage from "./ui/crehana-text-image";
import DecoratorBarError from "./ui/decorator-bar-error";
import { getSideImageByErrorCode } from "./utils/get-side-image-by-error-code";
import getTextByErrorCode from "./utils/get-text-by-error";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PageError = function PageError(_ref) {
  var title = _ref.title,
    buttonText = _ref.buttonText,
    helperText = _ref.helperText,
    reasonError = _ref.reasonError,
    onButtonClick = _ref.onButtonClick,
    headerComponent = _ref.headerComponent,
    _ref$errorCode = _ref.errorCode,
    errorCode = _ref$errorCode === void 0 ? 403 : _ref$errorCode,
    organizationSlug = _ref.organizationSlug,
    amplitudePageName = _ref.amplitudePageName,
    _ref$hideButton = _ref.hideButton,
    hideButton = _ref$hideButton === void 0 ? false : _ref$hideButton,
    footerErrorCode = _ref.footerErrorCode;
  var _useTranslationsError = useTranslationsError(),
    t = _useTranslationsError.t;
  var titleText = title || getTextByErrorCode(errorCode, {
    error401: function error401() {
      return t('DESCRIPTION_401');
    },
    error403: function error403() {
      return t('NO_PERMISSIONS_403_TITLE');
    },
    error500: function error500() {
      return t('NO_PERMISSIONS_500_TITLE');
    }
  });
  var shouldRenderButton = !hideButton && (!!onButtonClick || !!organizationSlug);
  var reasonText = (reasonError === null || reasonError === void 0 ? void 0 : reasonError.description) || getTextByErrorCode(errorCode, {
    error401: function error401() {
      return t('WHAT_HAPPENED_ERROR__401_DESCRIPTION');
    },
    error403: function error403() {
      return t('WHAT_HAPPENED_ERROR__403_DESCRIPTION');
    },
    error500: function error500() {
      return t('WHAT_HAPPENED_ERROR__500_DESCRIPTION');
    }
  });
  var ctaButtonText = buttonText || (errorCode === 401 ? t('CTA_DEFAULT_TEXT_401') : t('CTA_DEFAULT_TEXT'));
  var handleButtonClick = function handleButtonClick() {
    if (onButtonClick) {
      onButtonClick();
    } else if (organizationSlug) {
      window.location.href = createUrlWithSourceQueryParams({
        url: "/org/".concat(organizationSlug, "/home/"),
        source: amplitudePageName,
        sourceDetail: 'Button'
      });
    }
  };
  var errorMessageCode = {
    401: 'Unauthorized',
    403: 'Forbidden',
    500: 'Internal Server Error'
  }[errorCode] || 'Unknown Error';
  return /*#__PURE__*/_jsxs(Container, {
    className: "tw-h-screen tw-px-1 md:tw-px-0 tw-mb-2.4 md:tw-mb-0",
    role: "main",
    "aria-labelledby": "error-heading",
    children: [/*#__PURE__*/_jsx("div", {
      className: cn('tw-col-span-12', !!headerComponent && 'tw-mb-6.4 sm:tw-mb-5.6 md:tw-mb-0 tw-mt-2.4 md:tw-mt-3.6'),
      children: headerComponent
    }), /*#__PURE__*/_jsx("article", {
      className: "tw-col-span-12 sm:tw-col-span-6 tw-flex tw-flex-col tw-justify-center",
      children: /*#__PURE__*/_jsxs("div", {
        role: "region",
        "aria-labelledby": "error-heading",
        children: [errorCode === 401 ? /*#__PURE__*/_jsx("h1", {
          id: "error-heading",
          className: "tw-font-h1 tw-font-semibold tw-text-primary-light-500 tw-mb-2 tw-relative",
          "aria-label": "".concat(t('TITLE_401'), " ").concat(errorCode),
          children: t('TITLE_401')
        }) : /*#__PURE__*/_jsxs("h1", {
          id: "error-heading",
          className: "tw-font-h1 tw-font-semibold tw-text-primary-light-500 tw-mb-2 tw-relative",
          "aria-label": "".concat(t('TITLE_ERROR'), " ").concat(errorCode),
          children: [t('TITLE_ERROR'), ' ', /*#__PURE__*/_jsxs("div", {
            className: "tw-relative tw-inline-block",
            children: [/*#__PURE__*/_jsx("span", {
              "aria-label": t('LABEL_ERROR_CODE', {
                interpolation: {
                  errorCode: errorCode
                }
              }),
              children: errorCode
            }), /*#__PURE__*/_jsx("div", {
              className: "tw-absolute tw-right-[0.4rem] tw-bottom-[-1rem]",
              children: /*#__PURE__*/_jsx(DecoratorBarError, {
                alt: t('LABEL_ERROR_CODE', {
                  interpolation: {
                    errorCode: errorCode
                  }
                }),
                className: "tw-w-5.6 sm:tw-w-8.8"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx("h2", {
          className: "tw-font-h3 tw-text-gray-900 tw-mb-2.4 tw-font-semibold",
          children: titleText
        }), !!reasonText && /*#__PURE__*/_jsxs("section", {
          className: "tw-mb-3.2 tw-max-w-screen-xs",
          "aria-labelledby": "reason-heading",
          children: [/*#__PURE__*/_jsx("h3", {
            id: "reason-heading",
            className: "tw-font-subtitle4 tw-text-gray-900 tw-mb-2",
            children: (reasonError === null || reasonError === void 0 ? void 0 : reasonError.title) || t('WHAT_WENT_WRONG')
          }), /*#__PURE__*/_jsx("p", {
            className: "tw-font-body4 tw-p-2 tw-text-primary-light-400 tw-bg-primary-light-100 tw-rounded-1",
            role: "alert",
            "aria-live": "polite",
            children: reasonText
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: "tw-font-body5 tw-text-gray-600 tw-mb-2.4 tw-max-w-screen-xs",
          children: helperText || t('CONTACT_ADMIN')
        }), shouldRenderButton && /*#__PURE__*/_jsx(Button, {
          type: "button",
          variant: "primary",
          size: "lg",
          onClick: handleButtonClick,
          className: "tw-w-full sm:tw-w-auto tw-justify-center sm:tw-justify-start",
          children: ctaButtonText
        })]
      })
    }), /*#__PURE__*/_jsx(LazyImage, {
      src: getSideImageByErrorCode(errorCode),
      imgxParams: {
        w: 468,
        h: 608,
        q: 100,
        fit: 'crop'
      },
      alt: t('ALT_ERROR_IMAGE', {
        interpolation: {
          errorCode: errorCode
        }
      }),
      isTransparent: true,
      className: "tw-col-span-6 tw-w-full tw-min-w-[32rem] md:tw-min-w-full tw-h-full tw-min-h-[30rem] sm:tw-min-h-[50rem] md:tw-min-h-[60rem] tw-pointer-events-none",
      imgClassName: "tw-w-full tw-h-full tw-object-center tw-object-contain"
    }), /*#__PURE__*/_jsxs("footer", {
      className: "tw-col-span-12 tw-text-1.2 tw-text-neutral-light-500 tw-flex tw-items-center tw-gap-0.2 tw-justify-between",
      role: "contentinfo",
      "aria-label": t('LABEL_POWERED_BY_CREHANA'),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-items-center tw-gap-0.2",
        children: [_span || (_span = /*#__PURE__*/_jsxs("span", {
          children: ["Powered by ", /*#__PURE__*/_jsx(CrehanaTextImage, {})]
        })), /*#__PURE__*/_jsx(CrehanaLogo, {
          className: "tw-fill-current",
          size: 14,
          "aria-label": t('LABEL_LOGO_CREHANA')
        })]
      }), footerErrorCode ? /*#__PURE__*/_jsxs("div", {
        className: "tw-font-body3 tw-text-neutral-light-500",
        children: ["Error ", errorCode, " - ", errorMessageCode, " ", footerErrorCode]
      }) : null]
    })]
  });
};
export var PageErrorDefaultHeader = function PageErrorDefaultHeader() {
  return _img || (_img = /*#__PURE__*/_jsx("img", {
    src: "https://crehana-public-catalog.imgix.net/share-file/a1d7bd92/crehana-isologotype-morablue-f3105e7d.png",
    alt: "crehana",
    "aria-hidden": "true",
    width: "128",
    className: "tw-max-h-4 tw-w-auto tw-max-w-[12.8rem]"
  }));
};